// extracted by mini-css-extract-plugin
module.exports = {"Container":"DealLayout_Container__2f1V9","Transparent":"DealLayout_Transparent__7ZKU5","White":"DealLayout_White__JZDus"};